import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import * as Bank from "../index";
import {StoreContext} from "../../../store.context";
import {BankPrepareEditFormResponse} from "../../../types/modules/bank/response";

export const Edit: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { bankStore: { edit }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();
    const params = useParams();

    const data: BankPrepareEditFormResponse = useLoaderData() as BankPrepareEditFormResponse;

    const onCancel = () => {
        navigate(`/bank`)
    }

    return <Bank.Form onSave={(values) => { return edit({...values, id: params.id}) }} onCancel={onCancel} preparedData={data} />
})